import { useCallback, useContext, useState } from "react";
import { Checkbox, FormControlLabel, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";

import {
  Banner,
  BannerList,
  Button,
  PopupDialog,
  PopupDialogTitle,
} from "../../components/design-system/index.js";
import { LoggedInUserContext } from "../../Contexts.js";

export function TrainingWelcomeDialogSoad() {
  const userContext = useContext(LoggedInUserContext);
  const { t } = useTranslation();

  const [showTrainingBanner, setShowTrainingBanner] = useState(
    userContext?.user.sessionContext?.isTrainingOrganisation ?? false,
  );
  const [accepted, setAccepted] = useState(false);

  const onClose = useCallback(() => {
    // We don't want to allow the user to close the dialog until they accept the terms.
  }, []);
  const onContinue = useCallback(() => {
    setShowTrainingBanner(false);
  }, []);

  return (
    <PopupDialog open={showTrainingBanner} onClose={onClose}>
      <PopupDialogTitle
        closeDialog={onClose}
        titleText={t("training.soad.dialog.title")}
      />
      <Stack
        sx={{
          justifyContent: "center",
          alignItems: "center",
          gap: 1,
        }}
      >
        <Banner
          bannerType={BannerList.WARNING}
          body={(t("training.soad.dialog.banner") as string).split("\n")}
        />
        <FormControlLabel
          control={
            <Checkbox value={accepted} onClick={() => setAccepted(!accepted)} />
          }
          label={t("training.soad.dialog.confirmation")}
        />
        <Button
          label={t("buttonLabels.continue")}
          onClick={onContinue}
          color={"primary"}
          disabled={!accepted}
        />
      </Stack>
    </PopupDialog>
  );
}
